module.exports = __webpack_public_path__ + "img/uparrow-blue-small.c3da9b43.svg";